import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import axios from "axios";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Kits from "@/pages/Kits";
import Retailer from "@/pages/Retailer";
import Distributor from "@/pages/Distributor";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Calendar from "@/pages/Calendar";
import AdminAnalytics from "@/pages/AdminAnalytics";
import { CartProvider } from "@/lib/CartContext";
import { Toaster } from "@/components/ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Inject GA4 script if measurement ID is configured
function useGA4() {
  useEffect(() => {
    axios.get(`${API}/config/public`).then(({ data }) => {
      const id = data?.ga4_id;
      if (!id || !window.gtag) return;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(s);
      window.gtag("config", id, { send_page_view: false });
    }).catch(() => {});
  }, []);
}

function AppInner() {
  useGA4();
  return (
    <Routes>
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/kits" element={<Kits />} />
        <Route path="/retailer" element={<Retailer />} />
        <Route path="/distributor" element={<Distributor />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/calendar" element={<Calendar />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <CartProvider>
            <AppInner />
          </CartProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </HelmetProvider>
    </div>
  );
}

export default App;
